import {
  Text,
  Alert,
  AlertDescription,
  Box,
  Stack, Flex,
} from "@chakra-ui/react";
import { Wrapper } from "../components/Wrapper";
import { Jumbotron } from "../components/Jumbotron";
import { Features } from "../components/Features";
import { Prediction } from "../components/Prediction";
import { Token } from "../components/Token";
import { FAQ } from "../components/FAQ";
import { Roadmap } from "../components/Roadmap";
import { PartnersAndSupporters } from "../components/PartnersAndSupporters";
import Buy from "../components/Buy";
import {Community} from "../components/Community";

export const Home = () => {
  return (
    <Wrapper>
      <AlertMessage/>
      <Stack gap={32}>

        <Flex alignItems={"center"} justifyContent={"center"} textAlign={"center"} minH={"100vh"} mb={-32}>
          <Jumbotron/>
        </Flex>

        {/* <StatsBar></StatsBar> */}

        <Features/>
        <Prediction/>
        
        <Token/>

        <Buy></Buy>

        {/* <PredictionSlider></PredictionSlider> */}

        <Roadmap/>
        <FAQ/>
        <PartnersAndSupporters/>
        <Community/>
      </Stack>
    </Wrapper>
  );
};

// The overlay used to announce the $KUKU airdrop. It now carries the archive notice,
// and is no longer dismissible: a notice you can close stops being one on the next scroll.
function AlertMessage() {
  return (
    <Box position={"fixed"} bottom={0} left={0} width={'100%'} zIndex={2000}>
      <Alert status='info' backgroundColor={"gray.800"} justifyContent={"center"}>
        <Box>
          <AlertDescription>
            <Text fontSize={{base: "sm", md: "md"}} color={"gray.100"} textAlign={"center"}>
              <strong>Kuku Games is discontinued.</strong> This site is kept online as an
              archive of the project. Nothing on it is maintained, playable or operational.
            </Text>
          </AlertDescription>
        </Box>
      </Alert>
    </Box>
  )
}